<template>
  <div class="maxbox">
    <div>
      <div class="top">
      
        <div class="topid">
          <div id="walletAddress"> {{ shortWalletAddress }}</div>
          <div id="walletBalanceTop">余额: {{ walletBalanceTop }} TND </div>
        </div>
      </div>
      <div class="main">
        <div class="header">
          
          <p>Tornado</p>
        </div>
        <div class="affivhe">
          <img src="@/assets/images/gg.png" alt="">
          <div id="vipStatus" class="top-left-corner" style="color: yellow;">{{ memberStatus }}</div>
        </div>
        <div class="banner">
          <div class="item1">
            <div class="swiper mySwiper">
              <div class="swiper-wrapper">

                <!-- 图1 -->
                <div class="swiper-slide">
                  <div class="card1">
                    <img src="@/assets/images/ban-55.png" alt="">
                  </div>
                </div>

                <!-- 图2 -->
                <div class="swiper-slide">
                  <div class="card1">
                    <img src="@/assets/images/ban-66.png" alt="">
                  </div>
                </div>

                <!-- 图3 -->
                <div class="swiper-slide">
                  <div class="card1">
                    <img src="@/assets/images/ban-77.png" alt="">
                  </div>
                </div>

              </div>
              <!-- 分页器 -->
              <div class="swiper-pagination"></div>
            </div>
          </div>
        </div>
        <br>

   <!-- 标题 -->
   <div class="section-title">
      <div class="title-main">TORNADO 矿机中心</div>
      <div class="title-sub">高性能收益节点</div>
    </div>

        <!-- SBS1号矿机 -->
        <div class="community" style="display: flex;flex-direction: column;justify-content: center;">
          <h4 style="color:#3b7cf5;line-height:1.5">Miner 1 / M1<h6 style="color: red;">价格:42 Tornado<h6>有效期:200天<h6>日分红0.42枚</h6>
              </h6>
            </h6>
          </h4>
          <input type="number" v-model="machineCount1" placeholder="输入数量">
          <button @click="purchaseMachines(0, machineCount1)">购买</button>
          <img src="@/assets/images/kj2.png" alt="" style="background-color: transparent;">
        </div>

        <!-- SBS2号矿机 -->
        <div class="community" style="display: flex;flex-direction: column;justify-content: center;">
          <h4 style="color:#3b7cf5;line-height:1.5">Miner 2 / M2<h6 style="color: red;">价格:84 Tornado<h6>有效期:200天<h6>日分红1.05枚</h6>
              </h6>
            </h6>
          </h4>
          <input type="number" v-model="machineCount2" placeholder="输入数量">
          <button @click="purchaseMachines(1, machineCount2)">购买</button>
          <img src="@/assets/images/kj2.png" alt="" style="background-color: transparent;">
        </div>

        <!-- SBS3号矿机 -->
        <div class="community" style="display: flex;flex-direction: column;justify-content: center;">
          <h4 style="color:#3b7cf5;line-height:1.5">Miner 3 / M3<h6 style="color: red;">价格:126Tornado<h6>有效期:200天<h6>日分红1.89枚</h6>
              </h6>
            </h6>
          </h4>
          <input type="number" v-model="machineCount3" placeholder="输入数量">
          <button @click="purchaseMachines(2, machineCount3)">购买</button>
          <img src="@/assets/images/kj2.png" alt="" style="background-color: transparent;">
        </div>

        <div class="set">
          <input type="text" id="referrer-address" v-model="referrerAddress" placeholder="输入推荐人地址">
          <div class="input-group">
            <label for="machine-type">矿机类型：</label>
            <div class="custom-select" @click="toggleDropdown">
              <span>{{ selectedMachineType }}</span>
              <div class="select-items" v-if="showDropdown">
                <div @click.stop="selectMachineType(0)"> Miner 1 / M1</div>
                <div @click.stop="selectMachineType(1)"> Miner 2 / M2</div>
                <div @click.stop="selectMachineType(2)"> Miner 3 / M3</div>
              </div>
            </div>
          </div>
          <div class="input-group">
            <label for="machine-count">矿机数量：</label>
            <input type="number" id="machine-count" v-model="machineCount" min="1" placeholder="输入数量">
          </div>
          <button @click="registerMember">绑定推荐人并购买矿机</button>
        </div>

        <textarea id="clipboardContent" style="position: absolute; top: -9999px; left: -9999px;"></textarea>
      </div>
    </div>
  </div>
</template>

<script>
/* global ethereum */
import Swiper from 'swiper';
import { ethers } from 'ethers';
import { usdtTokenAddress, usdtAbi, contractAddress, contractABI } from '@/js/contract.js';

export default {
  name: 'home',
  data() {
    return {
      walletAddress: '未连接',
      shortWalletAddress: '未连接',
      walletBalanceTop: '0',
      memberStatus: '未获取',
      machineCount1: 1,
      machineCount2: 1,
      machineCount3: 1,
      machineCount: 1,
      machineType: 0,
      referrerAddress: '',
      showDropdown: false,
      selectedMachineType: 'Miner 1 / M1'
    };
  },
  mounted() {
    new Swiper(".mySwiper", {
      slidesPerView: 1,
      spaceBetween: 30,
      loop: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
    });

    this.connectWallet();
    this.getAndDisplayMemberStatus();
    this.populateReferrerFromURL(); // 调用解析URL参数的方法
  },
  methods: {
    async connectWallet() {
      if (window.ethereum) {
        try {
          const provider = new ethers.providers.Web3Provider(window.ethereum);
          await provider.send("eth_requestAccounts", []);
          const signer = provider.getSigner();
          const address = await signer.getAddress();

          const usdtContract = new ethers.Contract(usdtTokenAddress, usdtAbi, provider);
          const balance = await usdtContract.balanceOf(address);
          const balanceInUsdt = ethers.utils.formatUnits(balance, 6);
          const balanceInUsdtInt = Math.floor(balanceInUsdt);

          this.walletAddress = address;
          this.shortWalletAddress = `${address.slice(0, 6)}...${address.slice(-4)}`;
          this.walletBalanceTop = balanceInUsdtInt;

        } catch (error) {
          console.error(error);
          alert('连接钱包失败');
        }
      } else {
        alert('请安装 MetaMask 插件');
      }
    },
    async getAndDisplayMemberStatus() {
      if (!window.ethereum) {
        alert('请安装 MetaMask 插件');
        return;
      }

      try {
        await ethereum.request({ method: 'eth_requestAccounts' });
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        const signer = provider.getSigner();
        const userAddress = await signer.getAddress();
        const contract = new ethers.Contract(contractAddress, contractABI, provider);
        const status = await contract.getAccountStatus({ from: userAddress });

        this.memberStatus = status;
      } catch (error) {
        console.error('获取会员状态失败:', error);
        alert('获取会员状态失败，请查看控制台获取详细信息。');
      }
    },
    async registerMember() {
      const referrerAddress = this.referrerAddress;
      const machineType = this.machineType;
      const machineCount = parseInt(this.machineCount);

      if (!referrerAddress || machineCount <= 0) {
        alert('请输入推荐人地址并选择矿机数量');
        return;
      }

      if (window.ethereum) {
        try {
          await ethereum.request({ method: 'eth_requestAccounts' });
          const provider = new ethers.providers.Web3Provider(window.ethereum);
          const signer = provider.getSigner();
          const userAddress = await signer.getAddress();

          let machinePrice;
          if (machineType === 0) {
            machinePrice = 42;
          } else if (machineType === 1) {
            machinePrice = 84;
          } else if (machineType === 2) {
            machinePrice = 126;
          }
          const totalCost = ethers.utils.parseUnits((machineCount * machinePrice).toString(), 6);

          const usdtToken = new ethers.Contract(usdtTokenAddress, usdtAbi, signer);

          let allowance = await usdtToken.allowance(userAddress, contractAddress);
          if (!allowance.gte(totalCost)) {
            const approveTx = await usdtToken.approve(contractAddress, totalCost);
            await approveTx.wait();
          }

          const contract = new ethers.Contract(contractAddress, contractABI, signer);
          const tx = await contract.registerAndPurchase(referrerAddress, machineType, machineCount);
          await tx.wait();

          alert('注册成功并购买矿机');
        } catch (error) {
          console.error('注册过程中出错:', error);
          alert('注册失败。详情请查看控制台。');
        }
      } else {
        alert('请安装 MetaMask 插件');
      }
    },
    async purchaseMachines(machineType, machineCount) {
      if (machineCount <= 0) {
        alert('请输入有效的矿机数量');
        return;
      }

      try {
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        const signer = provider.getSigner();

        const contract = new ethers.Contract(contractAddress, contractABI, signer);
        let machinePrice = 0;
        if (machineType === 0) {
          machinePrice = 42;
        } else if (machineType === 1) {
          machinePrice = 84;
        } else if (machineType === 2) {
          machinePrice = 126;
        }
        const totalCost = ethers.utils.parseUnits((machineCount * machinePrice).toString(), 6);

        const usdtContract = new ethers.Contract(usdtTokenAddress, usdtAbi, signer);
        const allowance = await usdtContract.allowance(this.walletAddress, contractAddress);

        if (allowance.lt(totalCost)) {
          const approveTx = await usdtContract.approve(contractAddress, totalCost);
          await approveTx.wait();
        }

        const purchaseTx = await contract.purchaseMoreMachines(machineType, machineCount);
        await purchaseTx.wait();

        alert('购买成功');
      } catch (error) {
        console.error(error);
        alert('购买失败，请检查您的钱包余额或网络连接');
      }
    },
    populateReferrerFromURL() {
      const urlParams = new URLSearchParams(window.location.search);
      const referrer = urlParams.get('referrer');
      if (referrer) {
        this.referrerAddress = referrer;
      }
    },
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
      document.addEventListener('click', this.closeDropdown);
    },
    closeDropdown(event) {
      if (!this.$el.contains(event.target)) {
        this.showDropdown = false;
        document.removeEventListener('click', this.closeDropdown);
      }
    },
    selectMachineType(type) {
      this.machineType = type;
      this.selectedMachineType = `Miner ${type + 1}号矿机`;
      this.showDropdown = false;
    },
  },
};
</script>

<style scoped>
@import "@/assets/css/swiper-bundle.min.css";
@import "@/assets/css/index.css";
@import "@/assets/css/style.css";

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.loader svg {
  animation: rotate 2s linear infinite;
  width: 80px;
  height: 80px;
}

.arrow {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.input-group {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.input-group label {
  margin-right: 10px;
  width: 120px;
}

.input-group select,
.input-group input {
  flex: 1;
  padding: 5px;
  border: 1px solid #21977d;
  border-radius: 4px;
}

/* #walletAddress,
#walletBalanceTop {
  color: black;
} */

/* 更新后的样式 */
.input-group select,
.input-group input[type="number"] {
  flex: 0 0 195px;
  max-width: 195px;
  margin-left: -20px;
  /* 调整距离 */
}


/* 轮播容器 */
.banner .swiper {
  width: 100%;
  height: 100%;
  /* 父容器高度要设置，比如 300px / 500px 或 16:9 比例 */
}

/* 每个轮播项 */
.banner .swiper-slide {
  width: 100%;
  height: 120px;
}

/* 卡片容器 */
.card1 {
  width: 100%;
  height: 100%;
}


/* 核心：让图片完整适配容器 */
.card1 img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  /* 保持图片比例，铺满容器，超出部分裁剪 */
  /* 如果不想裁剪，改为 contain，图片会完整显示但可能有留白 */
  /* object-fit: contain; */
  display: block;
}

.avatar {
  width: 116px;
  height: 116px;
  object-fit: cover;
  border-radius: 50%;
}

.section-title {
  text-align: center;
  margin-bottom: 20px;
}

.title-main {
  font-size: 20px;
  font-weight: bold;
  color: #222;
}
.title-sub {
  font-size: 13px;
  color: #888;
  margin-top: 4px;
}

/* 自定义下拉框样式 */
.custom-select {
  position: relative;
  flex: 0 0 195px;
  max-width: 195px;
  margin-left: -20px;
  border: 1px solid #21977d;
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
  user-select: none;
}

.custom-select > span {
  display: block;
  padding: 6px 10px;
  font-size: 14px;
  color: #333;
}

/* 自定义下拉框样式 */
.custom-select {
  position: relative;
  flex: 0 0 195px;
  max-width: 195px;
  margin-left: -20px;
  border: 1px solid #3b7cf5;
  border-radius: 6px;
  background: rgba(255,255,255,0.9);
  cursor: pointer;
  user-select: none;
}
.custom-select > span {
  display: block;
  padding: 8px 12px;
  font-size: 14px;
  color: #222;
  font-weight: 500;
}

/* 下拉选项列表 */
.select-items {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: #ffffff;
  border: 1px solid #3b7cf5;
  border-radius: 0 0 6px 6px;
  margin-top: -1px;
  z-index: 999;
  max-height: 180px;
  overflow-y: auto;
}

/* 单个选项 */
.select-items div {
  padding: 10px 12px;
  font-size: 14px;
  color: #333;
}

/* hover 效果 - 主色匹配页面 */
.select-items div:hover {
  background-color: #3b7cf5;
  color: #fff;
}
</style>